/* @flow */

import _FieldWrapper from './FieldWrapper';

export default _FieldWrapper;



// WEBPACK FOOTER //
// ./src/components/FieldWrapper/index.js